// CarLinked EG — carlinked.js v3
(function(){
  'use strict';

  // Header scroll
  var header = document.querySelector('.cl-header-main');
  if(header){
    window.addEventListener('scroll', function(){
      header.classList.toggle('scrolled', window.scrollY > 60);
    }, {passive:true});
  }

  // Mobile nav
  var hamburger = document.getElementById('cl-hamburger');
  var mobileNav = document.getElementById('cl-mobile-nav');
  var overlay   = document.getElementById('cl-overlay');
  var closeBtn  = document.getElementById('cl-mobile-nav-close');
  function openNav(){
    if(mobileNav){ mobileNav.classList.add('open'); mobileNav.setAttribute('aria-hidden','false'); }
    if(overlay){ overlay.classList.add('open'); }
    document.body.style.overflow = 'hidden';
    if(hamburger) hamburger.setAttribute('aria-expanded','true');
  }
  function closeNav(){
    if(mobileNav){ mobileNav.classList.remove('open'); mobileNav.setAttribute('aria-hidden','true'); }
    if(overlay){ overlay.classList.remove('open'); }
    document.body.style.overflow = '';
    if(hamburger) hamburger.setAttribute('aria-expanded','false');
  }
  if(hamburger) hamburger.addEventListener('click', openNav);
  if(closeBtn)  closeBtn.addEventListener('click', closeNav);
  if(overlay)   overlay.addEventListener('click', closeNav);

  // Scroll reveal
  if('IntersectionObserver' in window){
    var revealObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('revealed'); revealObs.unobserve(e.target); }
      });
    }, {threshold:0.12});
    document.querySelectorAll('[data-reveal]').forEach(function(el){ revealObs.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function(el){ el.classList.add('revealed'); });
  }

  // FAQ Accordion
  document.querySelectorAll('.cl-faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = this.closest('.cl-faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.cl-faq-item.open').forEach(function(i){
        i.classList.remove('open');
        i.querySelector('.cl-faq-q').setAttribute('aria-expanded','false');
      });
      if(!isOpen){ item.classList.add('open'); this.setAttribute('aria-expanded','true'); }
    });
  });

  // Gallery thumbnails
  document.querySelectorAll('.cl-thumb-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var img = document.getElementById('cl-main-img');
      if(img){ img.src = this.dataset.src; img.alt = this.dataset.alt || ''; }
      document.querySelectorAll('.cl-thumb-btn').forEach(function(b){ b.classList.remove('active'); });
      this.classList.add('active');
    });
    btn.addEventListener('keydown', function(e){
      if(e.key==='Enter'||e.key===' '){ e.preventDefault(); btn.click(); }
    });
  });

  // Product tab switching
  document.querySelectorAll('.cl-tab-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var tab = this.dataset.tab;
      document.querySelectorAll('.cl-tab-btn').forEach(function(b){ b.classList.remove('active'); b.setAttribute('aria-selected','false'); });
      document.querySelectorAll('.cl-tab-panel').forEach(function(p){ p.classList.remove('active'); });
      this.classList.add('active'); this.setAttribute('aria-selected','true');
      var panel = document.getElementById('cl-tab-'+tab);
      if(panel) panel.classList.add('active');
    });
  });

})();
